import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '../../../components';
import { useModal } from '../../../hooks';
import { OperatorIcon2 } from '../../../assets/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentWebsite } from '../../../redux/websites/websites.actions';
import ModalOperatorsSearch from './ModalOperatorsSearch';
import ModalOperatorList from './ModalOperatorList';
import ModalAssignOperatorsAction from './ModalAssignOperatorsAction';
import { getDomainFromUrl } from '../../../utils';
import { fetchOperatorsStart } from '../../../redux/operators/operators.actions';
import useTranslation from 'hooks/useTranslation';

const mapState = (state) => ({
  currentWebsite: state.websitesData.currentWebsite,
  operators: state.operatorsData.operators,
});
const AssignOperatorsModal = ({
  websiteId,
  hasOperatorIcon,
  showSecondMenuAssignment,
}) => {
  const { operators, currentWebsite } = useSelector(mapState);
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState('');
  const [selectedOperatorIds, setSelectedOperatorIds] = useState([]);
  const [visible, toggle] = useModal();
  const selectedOperatorsCount = selectedOperatorIds.length;
  const domain = getDomainFromUrl(currentWebsite.url);
  const { getTranslation, getAppLocale } = useTranslation('WEBSITES');
  const { t } = getTranslation();
  const locale = getAppLocale();

  useEffect(() => {
    if (currentWebsite.operatorIds) {
      const alreadyAssignedOperators = currentWebsite.operatorIds;
      setSelectedOperatorIds(alreadyAssignedOperators);
    }
  }, [currentWebsite]);

  const handleSetCurrentWebsite = (event) => {
    if (event) event.preventDefault();
    toggle();
    dispatch(setCurrentWebsite(websiteId));
    if (
      !visible &&
      operators.data &&
      operators.data.length === 0 &&
      !operators.loading
    ) {
      dispatch(fetchOperatorsStart());
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const renderToggleButtonWithoutIcon = (
    <a
      href='#/'
      onClick={handleSetCurrentWebsite}
      className='btn btn-tertiary '
    >
      {t('ASSIGN_OPERATOR')}
    </a>
  );

  const renderToggleButtonWithIcon = (
    <a href='#/' onClick={handleSetCurrentWebsite} className='flex'>
      <img src={OperatorIcon2} alt='' />
      <p>{t('ASSIGN_OPERATOR')}</p>
    </a>
  );

  const renderOperatorsCount = (
    <>
      {`${selectedOperatorsCount} ${t('MODAL').ASSIGN_OPERATOR_OPERATOR}${
        locale === 'en' && selectedOperatorsCount > 1 ? 's' : ''
      }`}
    </>
  );

  const renderSecondMenuAssignment = (
    <div
      className={'second_menu_item_wrapper'}
      data-selected={false} // bcz a modal will popup
      onClick={(e) => {
        // dispatch(setSecondMenuCollapsed(true));
        handleSetCurrentWebsite(e);
      }}
    >
      {getAppLocale() === 'fa' ? 'تخصیص اپراتور' : 'Operator Assignment'}
    </div>
  );

  return (
    <>
      {!hasOperatorIcon &&
        !showSecondMenuAssignment &&
        renderToggleButtonWithoutIcon}
      {hasOperatorIcon &&
        !showSecondMenuAssignment &&
        renderToggleButtonWithIcon}
      {!!showSecondMenuAssignment && renderSecondMenuAssignment}
      <Modal visible={visible}>
        <ModalHeader title={t('MODAL').ASSIGN_OPERATOR_TITLE} subtitle={domain}>
          <div className='modal__container__header__operatorcount'>
            {renderOperatorsCount}
          </div>
        </ModalHeader>
        <ModalBody>
          <ModalOperatorsSearch
            title={t('MODAL').ASSIGN_OPERATOR_SEARCH}
            searchText={searchText}
            onSearch={handleSearch}
          />
          <div className='modal__container__body__agents'>
            <ModalOperatorList
              operators={operators}
              searchText={searchText}
              selectedOperatorIds={selectedOperatorIds}
              setSelectedOperatorIds={setSelectedOperatorIds}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <ModalAssignOperatorsAction
            toggle={toggle}
            selectedOperatorIds={selectedOperatorIds}
            websiteId={websiteId}
          />
        </ModalFooter>
      </Modal>
    </>
  );
};

AssignOperatorsModal.defaultProps = {
  hasOperatorIcon: false,
};

AssignOperatorsModal.propTypes = {
  websiteId: PropTypes.string.isRequired,
  hasOperatorIcon: PropTypes.bool,
};

export default AssignOperatorsModal;
